import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Message Alert Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-message-alert',
    templateUrl: './icon-message-alert.component.html',
    styleUrls: ['./icon-message-alert.component.scss'],
    standalone: false
})
export class IconMessageAlertComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
